import axios from "axios";
import {
  GET_PRESCRIPTIONS_REQUEST,
  GET_PRESCRIPTIONS_SUCCESS,
  GET_PRESCRIPTIONS_FAILURE,
  UPDATE_DELIVERY_STATUS_REQUEST,
  UPDATE_DELIVERY_STATUS_SUCCESS,
  UPDATE_DELIVERY_STATUS_FAILURE,
  ADD_DELIVERY_ADDRESS_REQUEST,
  ADD_DELIVERY_ADDRESS_SUCCESS,
  ADD_DELIVERY_ADDRESS_FAILURE,
  SET_SELECTED_PRESCRIPTION,
  PRESCRIPTION_DOWNLOAD_REQUEST,
  PRESCRIPTION_DOWNLOAD_SUCCESS,
  PRESCRIPTION_DOWNLOAD_FAILURE,
  CLEAR_MEDICAL_ERRORS,
  PRESCRIPTION_FIRST_ASSIGNED_REQUEST,
  PRESCRIPTION_FIRST_ASSIGNED_FAILURE,
  PRESCRIPTION_FIRST_ASSIGNED_SUCCESS,
  // Call prescriptionFirstAssigned API
} from "./medicalConstants";
import axiosInstance from "../../services/AxiosInstance";
import swal from "sweetalert";

// Get Prescriptions
export const getPrescriptions =
  (status = "ALL") =>
    async (dispatch, getState) => {
      try {
        dispatch({ type: GET_PRESCRIPTIONS_REQUEST });

        const payload = {};
        if (status && status !== "ALL") {
          payload.delivery_status = status;
        }

        const { data } = await axiosInstance.post(
          "/medical/getPrescriptions",
          payload
        );

        dispatch({
          type: GET_PRESCRIPTIONS_SUCCESS,
          payload: data,
        });

        return data;
      } catch (error) {
        dispatch({
          type: GET_PRESCRIPTIONS_FAILURE,
          payload: error.response?.data?.message || error.message,
        });
        throw error;
      }
    };

// Update Delivery Status
export const updateDeliveryStatus = (payload) => async (dispatch) => {
  try {
    dispatch({ type: "UPDATE_DELIVERY_STATUS_REQUEST" });

    // Format delivery details based on delivery option
    let formattedPayload = {
      patient_id: payload.patient_id,
      prescription_id: payload.prescription_id,
      delivery_option: payload.delivery_option,
      delivery_medicines: Array.isArray(payload.delivery_medicines)
        ? payload.delivery_medicines.join("|")
        : payload.delivery_medicines,
    };

    // Add delivery details for courier delivery
    if (payload.delivery_option === "BY_COURIER") {
      formattedPayload.delivery_details = JSON.stringify({
        delivery_status: payload.delivery_status,
        delivery_address_id: payload.delivery_address_id,
        delivery_partner: payload.delivery_partner,
        delivery_code: payload.delivery_code,
        delivery_date: payload.delivery_date,
        delivery_id: payload.delivery_id,
      });
    } else {
      // For by-hand delivery
      formattedPayload.delivery_details = JSON.stringify({
        delivery_status: "DELIVERED",
      });
    }

    console.log('🚚 Sending updateDeliveryStatus payload:', formattedPayload);

    const response = await axiosInstance.post(
      "/medical/updateDelieryStatus",
      formattedPayload
    );

    if (response.data.status === "success") {
      dispatch({
        type: "UPDATE_DELIVERY_STATUS_SUCCESS",
        payload: response.data.data,
      });

      // Refresh prescriptions to get updated status
      // dispatch(getPrescriptions());

      return { success: true, message: response.data.message };
    } else {
      throw new Error(
        response.data.message || "Failed to update delivery status"
      );
    }
  } catch (error) {
    dispatch({
      type: "UPDATE_DELIVERY_STATUS_FAILURE",
      payload: error.message,
    });
    return { success: false, message: error.message };
  }
};

// Add Delivery Address
export const addDeliveryAddress =
  (addressData) => async (dispatch, getState) => {
    try {
      dispatch({ type: "ADD_DELIVERY_ADDRESS_REQUEST" });

      const delivery_address = {
        addressLine1: addressData.addressLine1,
        addressLine2: addressData.addressLine2,
        area: addressData.area,
        city: addressData.city,
        state: addressData.state,
        country: addressData.country || "India",
        pincode: addressData.pincode,
        phoneNumber: addressData.phoneNumber,
      };

      const response = await axiosInstance.post("/medical/addDeliveryAddress", {
        patient_id: addressData.patient_id,
        delivery_address: JSON.stringify(delivery_address),
      });

      if (response.data.status === "success") {
        dispatch({
          type: "ADD_DELIVERY_ADDRESS_SUCCESS",
          payload: response.data.data,
        });

        // Re-fetch prescriptions to get updated address list
        dispatch(getPrescriptions("ALL"));

        return {
          success: true,
          data: response.data.data,
          message: response.data.message,
        };
      } else {
        throw new Error(
          response.data.message || "Failed to add delivery address"
        );
      }
    } catch (error) {
      dispatch({
        type: "ADD_DELIVERY_ADDRESS_FAILURE",
        payload: error.message,
      });
      return { success: false, message: error.message };
    }
  };

// Set Selected Prescription
export const setSelectedPrescription = (prescription) => ({
  type: SET_SELECTED_PRESCRIPTION,
  payload: prescription,
});

// Clear Medical Errors
export const clearMedicalErrors = () => ({
  type: CLEAR_MEDICAL_ERRORS,
});

// download prescripion
// export const downloadPrescription =
//   (patient_id, prescription_id) => async (dispatch, getState) => {
//     try {
//       dispatch({ type: PRESCRIPTION_DOWNLOAD_REQUEST });

//       console.log('🚚 Sending updateDeliveryStatus payload:', formattedPayload);

//     const response = await axiosInstance.post(
//         "/patient/downloadPrescriptionPdf",
//         {
//           patient_id,
//           prescription_id,
//         },
//         {
//           responseType: "blob",
//         }
//       );

//       const blob = new Blob([response.data], { type: "application/pdf" });
//       const url = window.URL.createObjectURL(blob);
//       const link = document.createElement("a");
//       link.href = url;
//       link.setAttribute("download", `Prescription-${prescription_id}.pdf`);
//       document.body.appendChild(link);
//       link.click();
//       link.remove();

//       dispatch({ type: PRESCRIPTION_DOWNLOAD_SUCCESS });
//       return { success: true };
//     } catch (error) {
//       dispatch({
//         type: PRESCRIPTION_DOWNLOAD_FAILURE,
//         payload: error?.response?.data?.message || error.message,
//       });
//       return {
//         success: false,
//         error: error?.response?.data?.message || error.message,
//       };
//     }
//   };
export const downloadPrescription =
  (patient_id, prescription_id) => async (dispatch, getState) => {
    try {
      dispatch({ type: PRESCRIPTION_DOWNLOAD_REQUEST });

      console.log("📄 Downloading prescription:", { patient_id, prescription_id });

      const response = await axiosInstance.post(
        "/patient/downloadPrescriptionPdf",
        { patient_id, prescription_id },
        { responseType: "blob" }
      );

      // ✅ Convert response data to PDF and trigger download
      const blob = new Blob([response.data], { type: "application/pdf" });
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", `Prescription-${prescription_id}.pdf`);
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(url); // cleanup

      dispatch({ type: PRESCRIPTION_DOWNLOAD_SUCCESS });
      return { success: true };
    } catch (error) {
      console.error("❌ Prescription download failed:", error);
      dispatch({
        type: PRESCRIPTION_DOWNLOAD_FAILURE,
        payload: error?.response?.data?.message || error.message,
      });
      return {
        success: false,
        error: error?.response?.data?.message || error.message,
      };
    }
  };


// Call prescriptionFirstAssigned API
export const prescriptionFirstAssigned =
  (prescription_id) => async (dispatch) => {
    try {
      dispatch({ type: PRESCRIPTION_FIRST_ASSIGNED_REQUEST });

      const { data } = await axiosInstance.post(
        "/servicecaller/prescriptionFirstAssigned",
        { prescription_id }
      );

      dispatch({
        type: PRESCRIPTION_FIRST_ASSIGNED_SUCCESS,
        payload: data,
      });

      return { success: true, data };
    } catch (error) {
      dispatch({
        type: PRESCRIPTION_FIRST_ASSIGNED_FAILURE,
        payload: error.response?.data?.message || error.message,
      });

      return {
        success: false,
        message: error.response?.data?.message || error.message,
      };
    }
  };